module.exports = "/images/ge-ab.svg?41c819f276c79f0d82d6a5dee356c026";